import { useTenant } from "@/hooks/useTenant";
import { useUserRole } from "@/hooks/useUserRole";
import { useEffect } from "react";
import { useNavigate } from "react-router";

// Re-export `UserManagement` as `UserManagementContent` for back-compat with
// existing call sites and spec imports. New code should import from
// `./AdminUsers/UserManagement` directly.
export { UserManagement as UserManagementContent } from "./AdminUsers/UserManagement";

/**
 * Legacy `/admin/users` route — redirects to the consolidated Settings page,
 * where User Management now lives as a tab (see SIM-1372 extraction).
 */
const AdminUsers = () => {
  const { tenantPath } = useTenant();
  const { isAdmin, isLoading: roleLoading } = useUserRole();
  const navigate = useNavigate();

  useEffect(() => {
    if (!roleLoading && !isAdmin) void navigate(tenantPath("/"));
  }, [isAdmin, roleLoading, navigate, tenantPath]);

  useEffect(() => {
    void navigate(tenantPath("/settings"));
  }, [navigate, tenantPath]);

  return null;
};

export default AdminUsers;
